import React from "react"
import { Typography } from "@material-ui/core"
import styled from "styled-components"
import SideFlourish from "../images/SideFlourish"
import useResponsive from "../utils/useResponsive"
//
//
const StyledDiv = styled.div`
  text-align: center;
  padding: 2rem;
  display: flex;
  justify-content: center;
  align-items: center;
`
const PageTitle = ({ title = "Default title" }) => {
  const { smUp } = useResponsive()
  return (
    <StyledDiv>
      {smUp && (
        <SideFlourish
          color={"silver"}
          height={25}
          style={{
            opacity: ".4",
            transform: "scale(-1)",
          }}
        />
      )}
      <Typography variant="h3" style={{ margin: "0 1rem" }}>
        {title}
      </Typography>
      {smUp && (
        <SideFlourish color={"silver"} height={25} style={{ opacity: ".4" }} />
      )}
    </StyledDiv>
  )
}

export default PageTitle
